import { useSelector } from 'react-redux';

import { emptyObject } from 'ui-components/default-props/empty';
import Global from '../../../store/global-selectors';

export const useEntitiesReturn = (returnFulfillmentId) =>
  useSelector((state) =>
    Global.selectEntitiesReturnById(state, {
      fulfillmentId: returnFulfillmentId,
    }),
  );

export const useEntitiesReturnsByReturnIds = (returnIds) =>
  useSelector((state) => Global.selectEntitiesReturnsByIds(state, { fulfillmentIds: returnIds }));

export const useEntitiesReturnProperty = (returnFulfillmentId, propertyName) => {
  return useSelector((state) => {
    const returnEntity =
      Global.selectEntitiesReturnById(state, {
        fulfillmentId: returnFulfillmentId,
      }) || emptyObject;
    return returnEntity[propertyName];
  });
};
